/** @jsxImportSource @emotion/react */
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ReactElement, ReactNode } from 'react';
import TopBar from '../Layouts/TopBar';
import RightSideBar from '../Layouts/RightSideBar';
import LeftSideBar from './LeftSidebar/index';

interface NavBarProps {
    rightSidebar?: ((ReactElement<any, any> & ReactNode) & ReactNode & JSX.Element) | null;
    leftSidebar?: ((ReactElement<any, any> & ReactNode) & ReactNode & JSX.Element) | null;
    className?: string;
    hideRightSidebar?: boolean;
}

const NavBar = (props: NavBarProps) => {
    const { rightSidebar, leftSidebar, className, hideRightSidebar } = props;

    return (
        <>
            <Container fluid className={`nav-bar ${className || ''}`}>
                <Row>
                    <Col xs={12}>
                        <TopBar />
                    </Col>
                    <Col xs={2}>{leftSidebar || <LeftSideBar />}</Col>
                    <Col xs={2}>
                        <RightSideBar hide={hideRightSidebar}>{rightSidebar}</RightSideBar>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default NavBar;
